module.exports = __webpack_public_path__ + "img/glow-yellow2-small.73f9f403.png";